import React
    from "react";

const HeroIcon: React.FC<HeroIconProps> = ({
                      height = 'h-6',
                      width = 'w-6',
                      title = "",
                      className = "",
                      color = "text-current",
                      componentName,
                      ...rest
                  }) => {
    const Component = componentName;
    return <Component className={`${height} ${width} ${color} ${className}`} title={title} aria-hidden="true" {...rest}/>
}

export default HeroIcon;

export type HeroIconProps = React.ComponentProps<'svg'> & {
    color?: string;
    title?: string;
    componentName: React.ElementType;
}